import React, { useEffect, useState } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import { API } from "../../utility/Api";
import Pagination from "@atlaskit/pagination";
import FilterIcon from "@atlaskit/icon/glyph/filter";
import RefreshIcon from "@atlaskit/icon/glyph/refresh";

import {
  TableWrapper,
  createHead,
  createCells,
} from "../../components/AuditLog/Table/Wrapper";

import Button from "@atlaskit/button";
import styles from "./AuditLog.module.css";
import {
  BackupEventTypes,
  pageSize,
  RestoreEventTypes,
  timeframeJobs,
} from "../../constants/constants";
import { CheckboxSelect, RadioSelect } from "@atlaskit/select";
import Badge from "@atlaskit/badge";

import Modal, {
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import { UseToast } from "../../components/context/ToastContext";
import Skeleton from "react-loading-skeleton";
import { sortAlhabetically } from "../../helpers/helpers";

const AuditLog = ({ appType }) => {
  let eventTypes = [];
  appType === "Backup"
    ? (eventTypes = BackupEventTypes)
    : (eventTypes = RestoreEventTypes);
  const [refresh, setRefresh] = useState(false);
  const [pagination, setPagination] = useState({
    page: "1",
    size: pageSize,
  });
  const [totalPages, setTotalPages] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showDownloadConfirm, setShowDownloadConfirm] = useState(false);
  const [downloadType, setDownloadType] = useState("csv");
  const { setMainMessage } = UseToast();
  const onPaginationChange = (e, page) => {
    setPagination((prevState) => ({
      page: page,
      size: prevState.size,
    }));
  };
  const [filterData, setFilterData] = useState({
    filter: {
      accountId: "",
      eventType: eventTypes.map((val) => val.value),
      sortBy: "id",
      timeframe: 1,
    },
  });
  const handleDownloadData = (type) => {
    // setLoading(true);
    // // eslint-disable-next-line
    // AP.context.getToken(function (token) {
    //   downloadFile(token, type);
    // });
    // const downloadFile = async (token, type) => {
    //   // setError("");
    //   setMainMessage("");
    //   const checkedIssueIdList = checkedIssues.map((val) => val.id);
    //   const data = {
    //     fileFormat: type,
    //     event_list: {
    //       selectedEvents: checkedIssueIdList,
    //       totalCount: checkedIssues.length,
    //     },
    //   };
    //   await API.post(`api/download_events`, data, {
    //     responseType: type === "csv" ? "arraybuffer" : "json",
    //     headers: {
    //       Authorization: `JWT ${token}`,
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then(function (response) {
    //       setCheckedIssues([]);
    //       const newCheckedItems = Object.fromEntries(
    //         Object.keys(checkedItems).map((key) => [key, false])
    //       );
    //       const newTempCheckedItems = Object.fromEntries(
    //         Object.keys(tempCheckedItems).map((key) => [key, false])
    //       );
    //       setGlobalCheckState({
    //         ...globalCheckState,
    //         allChecked: false,
    //       });
    //       setCheckedItems(newCheckedItems);
    //       setTempCheckedItems(newTempCheckedItems);
    //       // let jsonString;
    //       const fileName =
    //         `Revyz_QuickRestore_` +
    //         moment().utc().format("MM-DD-YYYY") +
    //         "-" +
    //         moment().utc().get("hour") +
    //         "-" +
    //         moment().utc().get("minute") +
    //         "-" +
    //         moment().utc().get("second");
    //       if (type === "json") {
    //         const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    //           JSON.stringify(response.data, null, 4)
    //         )}`;
    //         const link = document.createElement("a");
    //         link.href = jsonString;
    //         link.download = fileName + ".json";
    //         link.click();
    //         link.remove();
    //       } else if (type === "csv") {
    //         const jsonString = window.URL.createObjectURL(
    //           new Blob([response.data])
    //         );
    //         const link = document.createElement("a");
    //         link.href = jsonString;
    //         link.download = fileName + ".csv";
    //         link.click();
    //         link.remove();
    //       }
    //       setLoading(false);
    //     })
    //     .catch(function (error) {
    //       const data = errorHandler(error);
    //       setMainMessage({ appearance: "error", text: error.message });
    //       setLoading(false);
    //     });
    // };
  };

  const handleSetPage = (e) => {
    setPagination((prevState) => ({
      page: e ? e : "1",
      size: prevState.pagination.size,
    }));
  };
  const SingleValue = (props) => <strong>Interval : {props.data.label}</strong>;

  // const onProjectChange = (e) => {
  //   const projectValues = e.map((val) => val.value);
  //   setProjectValues(projectValues);
  // };

  // const onIssueTypeChange = (e) => {
  //   const issueType = e.map((val) => val.value);
  //   setIssueTypeValues(issueType);
  // };

  // const onTimeframeChange = (e) => {
  //   setTimeFrameValue(e ? [e.value] : ["lastDay"]);
  // };

  // const onEventChange = (e) => {
  //   checkEventValue.current = e;
  //   const eventValues = e.map((val) => val.value);
  //   setEventValues(eventValues);
  // };

  // const onInitiatorChange = (e) => {
  //   const userValues = e.map((val) => val.value);
  //   setInitiatorValues(userValues);
  // };

  // const handleFilters = () => {
  //   setCheckedIssues([]);
  //   setCheckedItems([]);
  //   setTempCheckedItems([]);
  //   setGlobalCheckState({
  //     allChecked: false,
  //     indeterminate: false,
  //     disabled: false,
  //   });
  //   if (searchKey) setSearchKey("");
  //   setPageData((prevState) => ({
  //     filter: {
  //       timeframe: timeframeValue ? timeframeValue : [],
  //       events: eventValues ? eventValues : [],
  //       projects: projectValues ? projectValues : [],
  //       issueTypes: issueTypeValues ? issueTypeValues : [],
  //       initiators: initiatorValues ? initiatorValues : [],
  //       sortFlag: prevState.filter.sortFlag,
  //       sortOrder: prevState.filter.sortOrder,
  //       sortingField: prevState.filter.sortingField,
  //     },
  //     pagination: { page: "1", size: "50" },
  //     totalCount: "",
  //     responseData: [],
  //   }));
  // };
  const MultiValue = ({ getValue, index }) => {
    const otherCount = getValue().length - 1;
    const BadgeNumber =
      otherCount > 0 ? <Badge appearance="primary"> +{otherCount} </Badge> : "";
    const display = `${getValue()[getValue().length - 1].label}`;
    return (
      !index && (
        <strong>
          Event Type :&nbsp;{display}
          &nbsp; {BadgeNumber}
        </strong>
      )
    );
  };

  let userNameList = [];
  let accountIdList = [];
  let avatarUrlList = [];
  const sendAllAccountId = (uniqueAccId, data) => {
    //Initialise data
    const initialdata = data.map((record) => {
      return { ...record, userName: "-", avatar: "" };
    });
    setTableData(initialdata);
    setLoading(false);
    var promise = new Promise(function (resolve, reject) {
      uniqueAccId.forEach((accountId, index) => {
        var promise2 = new Promise(function (resolve, reject) {
          //eslint-disable-next-line
          AP.request(`/rest/api/3/user?accountId=${accountId}`)
            .then((response) => {
              const responsedata = JSON.parse(response.body);
              resolve({
                displayName: responsedata.displayName,
                accountId: accountId,
                avatarUrl: Object.values(responsedata.avatarUrls)[1],
              });
            })
            .catch((e) =>
              reject({
                displayName: "Not found",
                accountId: accountId,
                avatarUrl: "",
              })
            );
        });
        promise2
          .then(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              resolve({
                nameList: userNameList,
                idList: accountIdList,
                avatarList: avatarUrlList,
              });
          })
          .catch(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              reject({
                nameList: userNameList,
                idList: accountIdList,
                avatarList: avatarUrlList,
              });
          });
      });
    });
    promise
      .then(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      })
      .catch(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      });
  };

  const updateUserDetails = (data, nameList, idList, avatarList) => {
    const newData = data.map((ele) => {
      let index = idList.indexOf(ele.accountId);
      return { ...ele, userName: nameList[index], avatar: avatarList[index] };
    });
    setTableData(newData);
    setLoading(false);
  };

  useEffect(() => {
    const getData = (token) => {
      // setMainMessage("");
      setLoading(true);
      const endpoint =
        appType === "Backup" ? "backup_auditlog" : "restore_auditlog";
      API.post(
        `api/${endpoint}?page=${pagination.page}&size=${pagination.size}`,
        filterData,
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
        .then(function (response) {
          sendAllAccountId(response.data.uniqueusers, response.data.auditdata);
          setTotalPages(response.data.totalCount);
        })
        .catch(function (error) {
          setMainMessage({ text: error.message, type: "error" });
          setLoading(false);
        });
    };

    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, refresh]);

  const handleStatusChange = (e) => {
    setFilterData((prevState) => ({
      filter: {
        accountId: prevState.filter.accountId,
        eventType: e.map((checkbox) => checkbox.value),
        sortBy: "id",
        timeframe: prevState.filter.timeframe,
      },
    }));
  };
  const handletimeframechange = (e) => {
    setFilterData((prevState) => ({
      filter: {
        accountId: prevState.filter.accountId,
        eventType: prevState.filter.eventType,
        sortBy: "id",
        timeframe: e.value,
      },
    }));
  };

  const head = createHead(true);
  const rows = createCells(tableData);

  return (
    <div className={styles.auditlogcontainer}>
      <ModalTransition>
        {showDownloadConfirm && (
          <Modal onClose={() => setShowDownloadConfirm(false)}>
            <ModalHeader>
              <ModalTitle>
                Are you sure you wish to download these items ?
              </ModalTitle>
            </ModalHeader>

            <ModalFooter>
              <Button
                appearance="subtle"
                onClick={() => setShowDownloadConfirm(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  handleDownloadData(downloadType);
                  setShowDownloadConfirm(false);
                }}
                appearance="primary"
                autoFocus
              >
                Download
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <div className={styles.auditTitle}>Revyz Audit Log</div>
      <div className={styles.actionbar}>
        <div className={styles.filtercontainer}>
          <div className={styles.filteritem}>
            <CheckboxSelect
              inputId="statusList"
              options={sortAlhabetically(eventTypes)}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              components={{ MultiValue }}
              placeholder="Status"
              selectLabel="Status"
              onChange={(e) => handleStatusChange(e)}
              isDisabled={isLoading}
              className="checkbox-select"
              classNamePrefix="react-select"
              isMulti
              defaultValue={eventTypes}
            />
          </div>
          <div className={styles.filteritem}>
            <RadioSelect
              inputId="time"
              className="radio-select"
              components={{ SingleValue }}
              classNamePrefix="react-select"
              defaultValue={timeframeJobs.filter(
                (type) => type.label === "Last 24 hours"
              )}
              options={timeframeJobs}
              placeholder="Timeframe"
              onChange={(e) => handletimeframechange(e)}
              isDisabled={isLoading}
            />
          </div>
        </div>
        <div className={styles.rightsidefilter}>
          <div>
            <Button
              appearance="default"
              type="submit"
              onClick={() => setRefresh(!refresh)}
              iconBefore={<FilterIcon size="small" />}
              isDisabled={isLoading}
            >
              Apply Filters
            </Button>
          </div>
          <div>
            <Button
              appearance="subtle"
              onClick={() => setRefresh(!refresh)}
              iconBefore={<RefreshIcon size="medium" />}
            ></Button>
          </div>
          <div className={styles.totalCount}>
            <strong>
              Total:&nbsp;
              {isLoading ? <Skeleton width={"20px"} /> : totalPages}
            </strong>
          </div>
        </div>
      </div>
      <div className={styles.tablecontainer}>
        <TableWrapper>
          <DynamicTable
            head={head}
            rows={rows}
            rowsPerPage={undefined}
            defaultPage={1}
            loadingSpinnerSize="large"
            isLoading={isLoading}
            isFixedSize
            onSetPage={handleSetPage}
            emptyView={<strong>No data found</strong>}
          />
        </TableWrapper>

        {totalPages !== 0 ? (
          <div className={styles.pagination}>
            <Pagination
              pages={Array.from({
                length: Math.ceil(totalPages / pagination.size),
              }).map((currentElement, i) => i + 1)}
              onChange={onPaginationChange}
              selectedIndex={pagination.page - 1}
            />
          </div>
        ) : (
          ""
        )}
        {/* <div className={styles.buttons}>
          <ButtonGroup className={styles.buttons}>
            <Popup
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              placement="bottom-start"
              content={() => (
                <div className={styles.content}>
                  <ButtonGroup appearance="subtle">
                    <Button
                      spacing="compact"
                      iconBefore={<Document16Icon label="Download JSON" />}
                      onClick={() => {
                        setDownloadType("json");
                        setShowDownloadConfirm(true);
                        // handleDownloadData("json");
                        setIsOpen(false);
                      }}
                    >
                      JSON
                    </Button>
                    <Button
                      spacing="compact"
                      iconBefore={
                        <ExcelSpreadsheet16Icon label="Download CSV" />
                      }
                      onClick={() => {
                        setDownloadType("csv");
                        setShowDownloadConfirm(true);
                        // handleDownloadData("csv");
                        setIsOpen(false);
                      }}
                    >
                      CSV
                    </Button>
                  </ButtonGroup>
                </div>
              )}
              trigger={(triggerProps) => (
                <Button
                  {...triggerProps}
                  iconBefore={
                    <ArrowDownIcon label="Quick restore" size="medium" />
                  }
                  appearance="default"
                  isSelected={isOpen}
                  isDisabled={isLoading}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  Download Data
                </Button>
              )}
            />
          </ButtonGroup>
        </div> */}
      </div>
    </div>
  );
};

export default AuditLog;
